import Button from "../../UI/Button";

export function PinCardSkeleton({ key }: { key: string }) {
  return (
    <div
      key={`skeleton-${key}`}
      className="column-medium-4 column-large-3 margin-bottom-4"
    >
      <div className="dashboard-pin-card" style={{ pointerEvents: "none" }}>
        <div className="pin-header row justify-content-between align-items-start no-wrap">
          <div
            className="column min-width-0"
            style={{ width: "100%", paddingRight: "16px" }}
          >
            {/* Title skeleton */}
            <div
              className="skeleton-pulse margin-bottom-2"
              style={{ height: "16px", width: "80%" }}
            />
            {/* Subtitle skeleton */}
            <div
              className="skeleton-pulse"
              style={{ height: "12px", width: "50%" }}
            />
          </div>
          <div className="pin-actions">
            {/* Menu dot skeleton */}
            <div
              className="skeleton-pulse"
              style={{ height: "28px", width: "28px", borderRadius: "5px" }}
            />
          </div>
        </div>

        <div className="pin-content">
          <div className="single-value-container">
            <div
              className="skeleton-pulse margin-bottom-2"
              style={{ height: "12px", width: "40px" }}
            />
            <div
              className="skeleton-pulse"
              style={{ height: "48px", width: "60%" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export function DashboardEmptyState({ onAddSummary, isRefreshing }: { onAddSummary: () => void, isRefreshing: boolean }) {
  return (
    <div className="dashboard-empty-state">
      <span className="icon">
        <i className="ri-pushpin-fill ri-4x margin-end-2" />
      </span>
      <h2 className="heading">No summaries pinned yet</h2>
      <p className="subheading">
        You can build your dashboard by pinning summaries from reports.
      </p>
      <div className="action">
        <Button
          id="add-first-summary"
          text="Add Summary"
          className="primary padding-vertical-4"
          onClick={onAddSummary}
          icon={<i className="ri-add-line margin-end-2" />}
          iconLocation="start"
          disabled={isRefreshing}
        />
      </div>
    </div>
  );
}

export function DashboardNotFoundState() {
  return (
    <div className="centered-container padding-4 center-text">
      <i className="ri-dashboard-line ri-4x text-danger margin-bottom-2" />
      <h2>Dashboard Not Found</h2>
      <p>This group dashboard could not be loaded or does not exist.</p>
    </div>
  );
}